export default class Modal {
  constructor($toggle) {
    this.$root = document.documentElement;
    this.$toggle = $toggle;
    this.modal = this.$toggle.getAttribute('data-target');
    this.$modal = document.getElementById(this.modal);

    if (!this.$modal) return console.warn('No modal found!', `#${this.modal}`);

    this.$backdrop = this.$modal.querySelector('.modal-backdrop');
    this.$dismisses = this.$modal.querySelectorAll('[data-dismiss="modal"]');
    this.$title = this.$modal.querySelector('.modal-title');

    this.title = this.$toggle.getAttribute('data-modal-title');

    this.hide = this.hide.bind(this);

    this.addEventListeners();
  }

  hide(event) {
    event.stopPropagation();
    this.$modal.style.display = '';
    this.$backdrop.removeEventListener('transitionend', this.hide, true);
  }

  addEventListeners() {
    this.$toggle.addEventListener('click', (event) => {
      this.$title.innerHTML = this.title;

      this.$modal.style.display = 'block';

      setTimeout(() => {
        this.$root.classList.toggle('modal-open');
        this.$modal.classList.toggle('show');
        // this.$modal.style.opacity = '1';
        this.$modal.style.pointerEvents = '';
      }, 30);

      event.preventDefault();
    });

    Array.from(this.$dismisses).forEach(($dismiss) => {
      $dismiss.addEventListener('click', (event) => {
        this.$backdrop.addEventListener('transitionend', this.hide, true);

        this.$root.classList.remove('modal-open');
        this.$modal.classList.remove('show');
        // this.$modal.style.opacity = '0';
        this.$modal.style.pointerEvents = 'none';

        event.preventDefault();
      });
    });
  }
}
